export const MATERIAL_URL = `https://node.matlib.net/material/`;
export const ROOT_SERVER = `https://node.matlib.net/`;
export const NIKESTORE = `https://node.matlib.net/brand/`;
//export const NIKESTORE = `http://localhost:3000/data/brand_data.json`;
